import React from "react";
//#region types
import { DateConstants } from "utils/constants";
import { WeeklyBannerProps } from "models/propTypes/timeReportingPropTypes";
import { TimeReportingEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import TimeReportingBanner from "../banner";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const WeeklyViewBanner: React.FC<WeeklyBannerProps> = (props) => {
  const { updatedWeek, weekData } = props;
  const [billableHours, setBillableHours] = React.useState<number>(0);
  const [internalHours, setInternalHours] = React.useState<number>(0);
  const [absenceHours, setAbsenceHours] = React.useState<number>(0);
  const [compHours, setCompHours] = React.useState<number>(props.compHours ?? 0);

  React.useEffect(() => {
    let deviationHours = 0;
    let projectHours = 0;
    let interHours = 0;
    DateConstants.FullWeekStartWithSunday.forEach((day) => {
      updatedWeek?.forEach((row) => {
        const hours = Number((row as any)[day]) ?? 0;
        if (hours > 0) {
          if (row.type === TimeReportingEnums.TimeReportType.deviation) {
            deviationHours += hours;
          } else if (row.type === TimeReportingEnums.TimeReportType.project) {
            if (row.isInternal) {
              interHours += hours;
            } else {
              projectHours += hours;
            }
          }
        }
      });
    });
    setBillableHours(projectHours);
    setAbsenceHours(deviationHours);
    setInternalHours(interHours);

    const totalNow = projectHours + deviationHours + interHours;
    const totalDiff = totalNow - apiTotal;
    if (totalDiff !== 0 || compHours !== props.compHours) {
      setCompHours((props.compHours ?? 0) + totalDiff);
    }
  }, [updatedWeek]);

  const apiTotal = React.useMemo(() => {
    let total = 0;
    DateConstants.FullWeekStartWithSunday.forEach((day) => {
      weekData?.forEach((row) => {
        const hours = Number((row as any)[day]) ?? 0;
        if (hours > 0) {
          total += hours;
        }
      });
    });
    return total;
  }, [weekData]);

  return (
    <TimeReportingBanner
      billableHours={billableHours}
      internalHours={internalHours}
      absenceHours={absenceHours}
      compHours={compHours}
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.TimeWeek)}
    ></TimeReportingBanner>
  );
};

export default WeeklyViewBanner;
